// extracted by mini-css-extract-plugin
module.exports = {"map_structure_desktop":"PageComponent_map_structure_desktop__16KxR","map_structure_compact":"PageComponent_map_structure_compact__60u89"};